// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infos p {
  font-size: 1.1rem;
}

.loading {
  width: 100%;
  text-align: center;
  margin-top: 65px;
}
.loading mat-spinner {
  margin: auto;
}

.room-image {
  width: 100%;
}

.bloc-rooms {
  margin-top: 15px;
}
.bloc-rooms .room {
  position: relative;
  width: 90%;
  padding: 10px;
  margin: 0 auto;
}
.bloc-rooms .room .room-image {
  width: 100%;
}
.bloc-rooms .room .close {
  position: absolute;
  right: 2px;
  top: 2px;
}
.bloc-rooms .div-action {
  margin-top: 20px;
}
.bloc-rooms .pastille {
  margin-right: 5px;
  width: 20px;
  height: 20px;
  border-radius: 50px;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+calendar/see-calendar/shared/components/dialog-see-event-details/dialog-see-event-details.component.scss"],"names":[],"mappings":"AACE;EACE,iBAAA;AAAJ;;AAIA;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;AADF;AAGE;EACE,YAAA;AADJ;;AAKA;EACE,WAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;AAIE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,cAAA;AAFJ;AAII;EACE,WAAA;AAFN;AAKI;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AAHN;AAOE;EACE,gBAAA;AALJ;AAQE;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EAGA,mBAAA;AANJ","sourcesContent":[".infos {\r\n  p {\r\n    font-size: 1.1rem;\r\n  }\r\n}\r\n\r\n.loading {\r\n  width: 100%;\r\n  text-align: center;\r\n  margin-top: 65px;\r\n\r\n  mat-spinner {\r\n    margin: auto;\r\n  }\r\n}\r\n\r\n.room-image {\r\n  width: 100%;\r\n}\r\n\r\n.bloc-rooms {\r\n  margin-top: 15px;\r\n\r\n  .room {\r\n    position: relative;\r\n    width: 90%;\r\n    padding: 10px;\r\n    margin: 0 auto;\r\n\r\n    .room-image {\r\n      width: 100%;\r\n    }\r\n\r\n    .close {\r\n      position: absolute;\r\n      right: 2px;\r\n      top: 2px;\r\n    }\r\n  }\r\n\r\n  .div-action {\r\n    margin-top: 20px;\r\n  }\r\n\r\n  .pastille {\r\n    margin-right: 5px;\r\n    width: 20px;\r\n    height: 20px;\r\n    -webkit-border-radius: 50px;\r\n    -moz-border-radius: 50px;\r\n    border-radius: 50px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
